<template>
  <main>
    <link v-if="isConfirm" id="confirm" :href="'./resources/' + (isSp ? 'sp' : 'pc') + '/css/style_confirm.css'" rel="stylesheet">
    <link v-else-if="isComplete" id="complete" :href="'./resources/' + (isSp ? 'sp' : 'pc') + '/css/style_thanks.css'" rel="stylesheet">
    <link v-else id="style_content1" :href="'./resources/' + (isSp ? 'sp' : 'pc') + '/css/style_content1.css'" rel="stylesheet">
    <template v-if="!isApplicationForm">
      <header v-if="isSp" class="headerSp" :style="{background: color}">
        <div class="wrap01">
          <h1 class="logo">
            <a :href="isComplete || isDownloadComplete ? '../' : '#'">
              <img :src="logoSP" alt="サービスロゴ">
            </a>
          </h1>
          <ul class="flow">
            <li><span :class="{'active': isCollection}">回収内容</span></li>
            <li><span :class="{'active': isCustomer}">お客様情報</span></li>
            <li><span :class="{'active': isConfirm}">内容確認</span></li>
            <li><span :class="{'active': isComplete}">申込み完了</span></li>
          </ul>
        </div>
      </header>
      <header v-else :style="{background: color}">
        <div class="header_content">
          <div class="header_title_box">
            <h1 class="logo">
              <a :class="{cursor_default: !isComplete && !isDownloadComplete}" :href="isComplete || isDownloadComplete ? '../' : '#'">
                <img :src="logoPC" alt="サービスロゴ">
              </a>
            </h1>
            <p class="header_title_txt" v-html="headWord"></p>
          </div>
          <ul class="flow">
            <li><span :class="{'active': isCollection}">回収内容</span></li>
            <li><span :class="{'active': isCustomer}">お客様情報</span></li>
            <li><span :class="{'active': isConfirm}">内容確認</span></li>
            <li><span :class="{'active': isComplete}">申込み完了</span></li>
          </ul>
        </div>
      </header>
    </template>

    <spinner v-show="isLoading" id="overlay"></spinner>
    <router-view></router-view>
    <template v-if="!isApplicationForm">
      <footer v-if="isSp">
        <div class="wrap01">
          <div class="footer_block">
            <p class="txt01" v-html="footerWord1Sp"></p>
          </div>
          <div class="footer_block">
            <p class="logo01"><img :src="footerImagePathSp" alt=""></p>
            <p class="txt01" v-html="footerWord2Sp"></p>
          </div>
        </div>
      </footer>
      <footer v-else>
        <div class="wrap05">
          <div class="footer_block">
            <p class="txt01" v-html="footerWord1Pc"></p>
          </div>
          <div class="footer_block">
            <p class="logo01"><img :src="footerImagePathPc" alt=""></p>
            <p class="txt01" v-html="footerWord2Pc"></p>
          </div>
        </div>
      </footer>
    </template>
  </main>
</template>

<script>
  import common from './js/common'
  import Spinner from 'vue-simple-spinner'
  import axios from 'axios'

  export default {
    data() {
        return {
          isSp: false,  // スマホ判定用
          isCollection: false,  // ヘッダの「回収内容」アクティブ表示切り替え用
          isCustomer: false,  // ヘッダの「お客様情報」アクティブ表示切り替え用
          isConfirm: false, // ヘッダの「内容確認」アクティブ表示切り替え用
          isComplete: false,  // ヘッダの「申込み完了」アクティブ表示切り替え用
          isDownloadComplete: false,  // ヘッダのロゴ機能切り替え用
          isLoading: false,  // API実行中のローディングスピナーの表示切り替え用
          isBack: false, // 戻るボタンを押下したか管理用
          color: '', // ヘッダの背景色
          logoPC: '', // ロゴ画像ファイルパス(PC用)
          logoSP: '', // ロゴ画像ファイルパス(SP用)
          footerWord1Pc: '',
          footerWord1Sp: '',
          footerWord2Pc: '',
          footerWord2Sp: '',
          footerImagePathPc: '',
          footerImagePathSp: '',
          headWord: '',
          isApplicationForm: false
        }
    },
    created() {
      this.isSmartPhone()
      this.initialStore()
      this.getSettings()
      this.getCodeInfo()
    },
    methods: {
      isSmartPhone() {
        this.isSp = common.isSmartPhone()
      },
      initialStore() {
        // 申込ID
        let applyId = common.getStore(this, 'itemsDataTax').apply_id
        if (applyId && this.$route.path !== common.constant.COMPLETE_PAGE_PATH) {
          // ストアリセット
          common.resetStore(this)
        }
      },
      async getSettings() {
        this.isLoading = true
        let func = (data) => {
          // ストアに保存
          common.setStore(this, 'settings', data)
          if (data.siteCodeInfo.length > 0) {
            this.color = data.siteCodeInfo[0].HEAD_COLOR
            this.logoSP = data.siteCodeInfo[0].LOGO_IMAGE_PATH_SP
            this.logoPC = data.siteCodeInfo[0].LOGO_IMAGE_PATH_PC
            this.footerWord1Pc = data.siteCodeInfo[0].FOOTER_WORD1_PC
            this.footerWord1Sp = data.siteCodeInfo[0].FOOTER_WORD1_SP
            this.footerWord2Pc = data.siteCodeInfo[0].FOOTER_WORD2_PC
            this.footerWord2Sp = data.siteCodeInfo[0].FOOTER_WORD2_SP
            this.footerImagePathPc = data.siteCodeInfo[0].FOOTER_IMAGE_PATH_PC
            this.footerImagePathSp = data.siteCodeInfo[0].FOOTER_IMAGE_PATH_SP
            this.headWord = data.siteCodeInfo[0].HEAD_WORD
            // サイト名を切り替え
            document.title = data.siteCodeInfo[0].SITE_NAME
            if (![1, 2].includes(data.siteCodeInfo[0].PRICING_METHOD)) {
              alert(this.$msg.ERROR.MSG_9993)
            }
          } else {
            alert(this.$msg.ERROR.MSG_9994)
          }
        }
        // サイトコードマスタ取得APIで各種設定を取得
        await axios.get(common.constant.GET_SETTINGS_URL)
        .then(response => {
          if (typeof response.data.err_msg === 'undefined') {
            func(response.data)
          } else {
            alert(response.data.err_msg)
          }
        }).catch(() => {
          alert(this.$msg.ERROR.MSG_9997)
        }).finally(() => {
          this.isLoading = false
        })
      },
      async getCodeInfo() {
        this.isLoading = true
        let func = (data) => {
          // ストアに保存
          common.setStore(this, 'codeInfo', data)
        }
        // コードマスタ取得APIで各種データを取得
        await axios.get(common.constant.GET_CODE_URL)
        .then(response => {
          if (typeof response.data.err_msg === 'undefined') {
            func(response.data)
          } else {
            alert(response.data.err_msg)
          }
        }).catch(() => {
          alert(this.$msg.ERROR.MSG_9997)
        }).finally(() => {
          this.isLoading = false
        })
      }
    },
    components: {
    Spinner
  }
  }
</script>
